<div id="warranty-submit-block0" class="warranty-submit-upload">
  <div class="popup-upload-headline popup-upload-title">
    <h3>{{ 'common.text_warranty_upload_file' | cxTranslate }}</h3>
    <button mat-dialog-close class="btn btn-link upload-close"></button>
  </div>
  <mat-dialog-content>
    <div class="popup-upload-body">
      <p class="attach-body-heading">
        {{ 'common.text_warranty_select_file_wish' | cxTranslate }}
      </p>
      <div class="popup-upload-wrapper files" id="files0">
        <input type="hidden" class="hiddenLoopIndex" value="0" />
        @if (isUploadfileSuccess) {
          <div class="popup-alert-msg files-success-alert">
            <img src="/images/info-green.svg" alt="File upload success" />
            <span class="text">{{ 'common.text_warranty_select_all_files' | cxTranslate }}</span>
          </div>
        }
        @if (isMaxFileSize) {
          <div class="popup-alert-msg files-danger-alert">
            <img src="/images/info-red.svg" alt="File Max Size Error" />
            <span class="text">
              {{ 'common.text_select_you_can_upload' | cxTranslate }}
            </span>
          </div>
        }
        @if (isDuplicateFile) {
          <div class="popup-alert-msg files-danger-alert-duplicate">
            <img src="/images/info-red.svg" alt="File Duplicate error" />
            <span class="text">
              {{ 'common.text_warranty_duplicate_file_error' | cxTranslate }}
            </span>
          </div>
        }
        <p>{{ 'common.text_select_you_path_upload' | cxTranslate }}</p>
        <p></p>
        <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-9">
            <input type="file" #file (input)="fileSelector(file)"
              accept=".doc, .docx, .xls, .xlsx, .csv, .txt, .tif, .gif, .jpg, .pdf, image/*, .HTML"
              class="form-control warranty-fileUpload warranty-fileUpload-input input-files-part-no"
              multiple />
            </div>
            <div class="col-xs-12 col-sm-12 col-md-3 upload-btn-block">
              <button class="btn btn-primary blue-btn create-file-data-btn uploadAttachment"
                (click)="fileUploadFunction(_data?.index)" type="button"
                [disabled]="isAtleastOnefileIsThere">
                {{ 'common.text_warranty_button_uploadFile' | cxTranslate }}
              </button>
            </div>
          </div>
          <div class="warranty-upload-note">{{ 'common.text_select_file_type_upload' | cxTranslate }}<br /></div>
          <div class="popup-upload-fileLists">
            @if (fileLength$ | async; as fileCount) {
              <div class="upload-fileList-result">
                {{ 'common.text_select_you_record_sets' | cxTranslate }}
                <span class="upload-fileList-result-number">{{ fileCount }}</span>
              </div>
            } @else {
              <div class="upload-fileList-result">
                {{ 'common.text_select_you_record_sets' | cxTranslate }}
                <span class="upload-fileList-result-number">0</span>
              </div>
            }
            <ul>
              <li class="hidden-xs hidden-sm">
                <ul class="item__list--header upload-table-labels">
                  <li class="item__sort">#</li>
                  <li class="item__name">{{ 'common.text_warranty_name' | cxTranslate }}</li>
                  <li class="item__size">{{ 'common.text_warranty_size' | cxTranslate }}</li>
                  <li class="item__remove"></li>
                </ul>
              </li>
              <li class="item__list--item js-li-container upload-block">
                @if (fileCurrentFiles$ | async; as currentFiles) {
                  @for (file of currentFiles; track file; let i = $index) {
                    <ul class="fileList">
                      <li>
                        <div class="item__sort_tr">{{ i + 1 }}</div>
                        <div class="item__name_tr">{{ currentFiles[i].name }}</div>
                        <div class="item__size_tr">{{ currentFiles[i].size | number : '1.2-2' }}&nbsp;KB
                        </div>
                        <div class="removeFile_tr">
                          <button class="btn btn-link btn-remove" (click)="removeFile(file)">
                            {{ 'common.text_remove' | cxTranslate }}
                          </button>
                        </div>
                      </li>
                    </ul>
                  }
                }
              </li>
            </ul>
          </div>
        </div>
      </div>
    </mat-dialog-content>
  </div>